import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class PreventiveMaintenanceEditService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private datePipe: DatePipe,
        private http: Http,
        private httpClient: HttpClient
    ) {}
    assignEquipment(id, pmequipmentListModel) : Observable<any> {
        const url = this.urlPrefix + `pms/${id}/equipment`;

        return this.httpClient
            .put(url, {
                pmequipmentListModel: pmequipmentListModel,
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200 || res.status === 201) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }

    edit(id, post, pmequipmentListModel, pmuserAssignModels): Observable<any> {
        const url = this.urlPrefix + 'pms/' + id ;

        const teamIds = [];
        for (const team of post.teamIds.value) {
          teamIds.push(team.id);
        }

        return this.httpClient
            .put(url, {
                status : post.status.value,
                schedule: post.schedule.value,
                remarks : post.remarks.value,
                teamIds : teamIds,
                tentativeBeginDate : this.datePipe.transform(post.tentativeBeginDate.value, 'yyyy-MM-dd HH:mm:ss'),
                tentativeFinishDate : this.datePipe.transform(post.tentativeFinishDate.value, 'yyyy-MM-dd HH:mm:ss'),
                pmServiceBeginDate : this.datePipe.transform(post.pmServiceBeginDate.value, 'yyyy-MM-dd HH:mm:ss'),
                pmServiceFinishDate : this.datePipe.transform(post.pmServiceFinishDate.value, 'yyyy-MM-dd HH:mm:ss'),
                pmequipmentListModel: pmequipmentListModel,
                userAssignModels: pmuserAssignModels

            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 201) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-edit/preventive-maintenance-edit.service.ts